import { baseThemeValues } from 'constants/common';

export const breadCrumbTheme = {
  backLink: {
    fontFamily: baseThemeValues.inherit,
    fontSize: '16px',
    fontWeight: 500,
    text: 'palette.tertiary.60',
  },
  disabledLink: 'palette.neutral.50',
  separator: 'palette.neutral.50',
};
